<template>
    <!-- separated price to enable determine the price to show in times of SALE or SOLD -->
    <div>
        <!-- check if item was sold -->
        <template v-if="item.sold">
            <span v-if="item.donation">DONATED</span>
            <span v-else>SOLD</span>
        </template>
        <template v-else>
            <!-- check if item is for donation -->
            <template v-if="item.donation">FREE</template>
            <template v-else>
                <!-- display the current item price -->
                {{itemPrice.currency.toUpperCase()}} {{itemPrice.price | money}}
                
                <!-- check if item is on sale, display original price -->
                <span v-if="item.onSale" class="strikeout">{{item.price | money}}</span>
            </template>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "ItemPrice",
    props: {
        item: {
            type: Object,
            required: true
        },
        itemQty: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            itemPrice: null
        }
    },
    methods: {
        theItemPrice(theItemObj, theItemQty) { 
            if(!theItemObj) return

            // check if item is on sale
            let currentPrice = theItemObj.onSale ? theItemObj.onSalePrice : theItemObj.price
            
            // manipulate the price to show SOLD or SALE later here
            this.itemPrice = {
                price: theItemQty ? parseInt(theItemQty * currentPrice) : currentPrice,
                currency: theItemObj.currency,
            }
            // convert the item price from US Dollar to Nigeria Naira using our rate
            if(this.theCurrency){ 
                this.itemPrice.price *= this.theCurrency.rate
                this.itemPrice.currency = this.theCurrency.code
            }
        },
    },
    computed: {
        ...mapGetters(['setCurrency']),
        theCurrency() {
            if(this.setCurrency) {
                return this.setCurrency
            }
            return false
        },
    },
    watch: {
        item() {
            this.theItemPrice(this.item, this.itemQty)
        },
        itemQty() {
            this.theItemPrice(this.item, this.itemQty)
        },
    },
    created() {
        this.theItemPrice(this.item, this.itemQty)
    }
}
</script>
